import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"
import { Printer } from "../elements/Printer"

export class PagePrintOrder implements ClientPage {
  getPageId = (): string => "print-order"

  execute = (): void => {
    Printer.printWhenReady()
  }

  onPageClose = (): void => {}
}
